// USSD and SMS PIN rules (FR-81), the same as the server's: 4–6 digits, and not
// trivial (one digit repeated, or a straight run up or down like 1234/654321).

export type PinProblem = "err_format" | "err_trivial" | "err_mismatch";

export const PIN_PATTERN = /^[0-9]{4,6}$/;

/** isTrivialPin reports a PIN made of one repeated digit or a straight run up or down. */
export function isTrivialPin(pin: string): boolean {
  const digits = [...pin].map(Number);
  const steps = digits.slice(1).map((d, i) => d - (digits[i] ?? d));
  const step = steps[0];
  if (step === undefined || Math.abs(step) > 1) return false;
  return steps.every((s) => s === step);
}

/** pinProblem returns the ussd_pin.* message key for the first problem, or null when the PIN can be saved. */
export function pinProblem(pin: string, confirm: string): PinProblem | null {
  if (!PIN_PATTERN.test(pin)) return "err_format";
  if (isTrivialPin(pin)) return "err_trivial";
  if (pin !== confirm) return "err_mismatch";
  return null;
}
